import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewStudentCategory = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('student-management/student-category', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const activeStudentCategory = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('student-management/student-category/active', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const activeStudentCategoryBySchool = (schoolId) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school/student-category/' + schoolId, null).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addStudentCategory = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('student-management/student-category/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getStudentCategory = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('student-management/student-category/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editStudentCategory = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('student-management/student-category/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const toggleStudentCategory = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('student-management/student-category/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
